export default __webpack_public_path__ + "static/media/J7Icon.15a070f9.png";